// Shared DOM helpers. `esc()` is the single canonical HTML-escape used
// everywhere user content is rendered into a template string. It used to be
// copy-pasted (in ~27 slightly-divergent variants) across pages/components;
// this is the one source of truth.
//
// Behaviour (superset of every prior copy, so none is downgraded):
//   - null / undefined        → ''
//   - 0 / false / other       → their string form (so a real 0 shows as "0")
//   - escapes & < >           → entities (via textContent round-trip)
//   - escapes " and '         → &quot; / &#39; so the result is also safe
//                               inside double/single-quoted HTML attributes
//   - tolerates a torn-down jsdom (async test pipelines resolving after the
//     test finishes) by falling back to a pure string replace.

export function esc(s) {
  if (s == null) return '';
  const str = String(s);
  if (typeof document === 'undefined' || !document.createElement) {
    return str.replace(/[<>&"']/g, c => (
      { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' }[c]
    ));
  }
  const d = document.createElement('div');
  d.textContent = str;
  // textContent→innerHTML escapes & < > but NOT quotes; escape them too so
  // esc() is attribute-safe as well as element-content-safe.
  return d.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
